import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom'

import useTitle from 'common/use-title'
import IntegrationConfiguration from 'components/IntegrationConfiguration'
import { NoPermissionsSplashPage } from 'components/NoPermissionsSplashPage'

import FilesTable from './FilesTable'
import HandraisersSplash from './Splash'

interface HandraisersRouteProps extends RouteComponentProps {
  supportsHandraisers: boolean
  canViewHandraisers: boolean
}
const HandraisersRoute = ({ match, supportsHandraisers, canViewHandraisers }: HandraisersRouteProps) => {
  useTitle('Scoir - Handraisers')

  // Check college level feature
  if (!supportsHandraisers) {
    return <HandraisersSplash />
  }
  // Check user permissions to view handraisers
  if (!canViewHandraisers) {
    return <NoPermissionsSplashPage />
  }

  return (
    <Switch>
      <Route
        exact
        path={`${match.path}/files`}
        render={() => <FilesTable />}
      />
      <Route
        exact
        path={`${match.path}/integrations`}
        render={() => <IntegrationConfiguration />}
      />
      <Redirect
        exact
        from={match.path}
        to={`${match.path}/files`}
      />
    </Switch>
  )
}

export default HandraisersRoute
